var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/naming-convention -- the current settings do not make much sense in JSX environment */
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { FilespaceStatus, LoginType } from '@lucidlink/dto/validation';
import { translate } from '@lucidlink/uicore';
import { FilespaceCard as FilespaceCardBase, filespaceIconDefaultImage, filespaceIconDisconnectedErrorImage, filespaceIconRestrictedImage, filespaceIconUpgradingImage, UpgradeFilespaceFeatureFlagProperties, useAuthProvider, useFilespaceById, useFilespaceCapabilities, useIsEnabledFeatureFlag, } from '@lucidlink/workspacemanagement';
import { FilespaceMenu } from '../menus';
import { StatusTextError, StatusTextInProgress, StatusTextSettingUp, StatusTextUpgrading, } from './components';
import { getStatusAnnouncement, getUpgradeIndicatorContent } from './services';
export const FilespaceCard = ({ filespace: filespaceDataFromList, }) => {
    _react_refresh_temp_2();
    const { currentUser } = useAuthProvider();
    const isLoggedWithCode = currentUser?.loginType === LoginType.VERIFICATION_CODE;
    const { query: { data: filespaceData, isError: isErrorFilespace }, } = useFilespaceById(filespaceDataFromList.workspaceId, filespaceDataFromList.id);
    const { isEnabledFeatureFlag } = useIsEnabledFeatureFlag();
    const filespace = !filespaceData || isErrorFilespace
        ? filespaceDataFromList
        : filespaceData;
    const { data: { canUpgrade }, } = useFilespaceCapabilities({
        workspaceId: filespace.workspaceId,
        filespace,
    });
    const filespaceStatus = filespace.status;
    const StatusText = useMemo(() => {
        if (filespace.isMigrating) {
            return StatusTextUpgrading;
        }
        else if (filespaceStatus === FilespaceStatus.SUSPEND_IN_PROGRESS ||
            filespaceStatus === FilespaceStatus.UNSUSPEND_IN_PROGRESS) {
            return StatusTextInProgress;
        }
        else if (filespaceStatus === FilespaceStatus.SETUP_IN_PROGRESS) {
            return StatusTextSettingUp;
        }
        else if (filespaceStatus === FilespaceStatus.ERRORED ||
            filespaceStatus === FilespaceStatus.SETUP_ERROR ||
            filespaceStatus === FilespaceStatus.SUSPEND_ERROR ||
            filespaceStatus === FilespaceStatus.UNSUSPEND_ERROR) {
            return StatusTextError;
        }
        else {
            return undefined;
        }
    }, [filespace.isMigrating, filespaceStatus]);
    let statusTextTooltipContent;
    if (filespaceStatus === FilespaceStatus.SETUP_ERROR) {
        statusTextTooltipContent = [
            translate('Filespace setup operation failed'),
        ];
    }
    else if (filespaceStatus === FilespaceStatus.SUSPEND_ERROR) {
        statusTextTooltipContent = [
            translate('Filespace suspend operation failed'),
        ];
    }
    else if (filespaceStatus === FilespaceStatus.UNSUSPEND_ERROR) {
        statusTextTooltipContent = [
            translate('Filespace unsuspend operation failed'),
        ];
    }
    else {
        statusTextTooltipContent = null;
    }
    const contextMenuOptions = useMemo(() => {
        if (filespace.settings.restrictWebAccess || isLoggedWithCode) {
            return null;
        }
        if (filespaceStatus === FilespaceStatus.READY ||
            filespaceStatus === FilespaceStatus.SETUP_IN_PROGRESS ||
            filespaceStatus === FilespaceStatus.SUSPEND_IN_PROGRESS ||
            filespaceStatus === FilespaceStatus.UNSUSPEND_IN_PROGRESS ||
            filespaceStatus === FilespaceStatus.ERRORED ||
            filespaceStatus === FilespaceStatus.SETUP_ERROR ||
            filespaceStatus === FilespaceStatus.SUSPEND_ERROR ||
            filespaceStatus === FilespaceStatus.UNSUSPEND_ERROR) {
            return _jsx(FilespaceMenu, { filespace: filespace });
        }
        else {
            return null;
        }
    }, [filespace, filespaceStatus, isLoggedWithCode]);
    const filespaceIconSrc = useMemo(() => {
        if (filespace.isMigrating) {
            return filespaceIconUpgradingImage;
        }
        else if (filespace.settings.restrictWebAccess) {
            return filespaceIconRestrictedImage;
        }
        else if (filespaceStatus === FilespaceStatus.ERRORED ||
            filespaceStatus === FilespaceStatus.SETUP_ERROR ||
            filespaceStatus === FilespaceStatus.SUSPEND_ERROR ||
            filespaceStatus === FilespaceStatus.UNSUSPEND_ERROR) {
            return filespaceIconDisconnectedErrorImage;
        }
        else {
            return filespaceIconDefaultImage;
        }
    }, [
        filespace.isMigrating,
        filespace.settings.restrictWebAccess,
        filespaceStatus,
    ]);
    const navigate = useNavigate();
    const navigateUrl = useMemo(() => {
        if (isLoggedWithCode) {
            return `/workspaces/${filespace.workspaceId}/filespaces/${filespace.id}/browser`;
        }
        return `/workspaces/${filespace.workspaceId}/filespaces/${filespace.id}/dashboard`;
    }, [filespace.workspaceId, filespace.id, isLoggedWithCode]);
    const indicatorContent = canUpgrade &&
        isEnabledFeatureFlag(UpgradeFilespaceFeatureFlagProperties)
        ? getUpgradeIndicatorContent(filespace)
        : null;
    return (_jsx(FilespaceCardBase, { contextMenuOptions: contextMenuOptions, filespace: filespace, ...(indicatorContent && { indicatorContent }), onClick: () => void navigate(navigateUrl), statusAnnouncement: getStatusAnnouncement(filespace), statusImageSrc: filespaceIconSrc, StatusText: StatusText, statusTextTooltipContent: statusTextTooltipContent }));
};
_react_refresh_temp_1 = FilespaceCard;
$RefreshReg$(_react_refresh_temp_1, "FilespaceCard");
_react_refresh_temp_2(FilespaceCard, "PhqLHwsDF5kNv1YHdFr9x7h+vVY=", false, () => [useAuthProvider, useFilespaceById, useIsEnabledFeatureFlag, useFilespaceCapabilities, useNavigate]);
